import { useMutation, useQuery } from '@tanstack/react-query';

import { AccountUpdateRequest } from '../models/AccountUpdateRequest';
import { ProfileResponse } from '../models/ProfileResponse';
import axiosBearerClient from '../axiosBearerClient';

export const useGetAccount = ({ enabled }: { enabled: boolean } = { enabled: true }) => {
  const { isFetching, error, data, isError, refetch } = useQuery({
    queryKey: ['accounts'],
    gcTime: 0,
    enabled: enabled,
    retry: false,
    queryFn: async () => {
      return await axiosBearerClient.get<ProfileResponse>('/accounts');
    },
  });

  return {
    isFetching,
    error,
    isError,
    data,
    refetch,
  };
};

export const useUpdateAccount = () => {
  const { isPending, error, data, isError, mutateAsync } = useMutation({
    retry: false,
    mutationFn: async (account: AccountUpdateRequest) => {
      return await axiosBearerClient.put(`/accounts`, account);
    },
  });

  return {
    isPending,
    error,
    isError,
    data,
    mutateAsync,
  };
};
